const convertFailed = sampleCollection => sampleCollection.error

export default convertFailed